// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__38OVr","rowsWrapper":"style_rowsWrapper__1vtLh","rowWrapper":"style_rowWrapper__234P3"};